import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import 'src/assets/css/ComplexSwipeContent.css';

const ComplexSwipeContent = ({
  icon, label, position, css
}) => (
  position === 'right'
    ? (
      <div className={`complex-swipeable-list__item-content-${css}`}>
        <div className="complex-swipeable-list__content" />
        <Grid container spacing={0}>
          <Grid item xs={6} align="center" />
          <Grid item xs={4} align="center">
            <span className="complex-swipeable-list__label">
              {label && <span>{label}</span>}
              {' '}
            </span>
          </Grid>
          <Grid item xs={2} align="center">
            <span className="complex-swipeable-list__icon">{icon}</span>
          </Grid>
        </Grid>
      </div>
    )
    : (
      <div className={`complex-swipeable-list__item-content-${css}`}>
        <div className="complex-swipeable-list__content" />
        <Grid container spacing={0}>
          <Grid item xs={2} align="center">
            <span className="complex-swipeable-list__icon">{icon}</span>
          </Grid>
          <Grid item xs={2} align="center">
            <span className="complex-swipeable-list__label">
              {label && <span>{label}</span>}
              {' '}
            </span>
          </Grid>
          <Grid item xs={8} align="center" />
        </Grid>
      </div>
    )
);

ComplexSwipeContent.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right']).isRequired
};

export default ComplexSwipeContent;
